import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MfpcPrimeComponent } from './components/mfpc-main/mfpc-main.component';
import { ArrSmartComponent } from './components/arr-smart/arr-smart.component';
import { ArrSmartShowModeComponent } from './components/arr-smart-show-mode/arr-smart-show-mode.component';
import { SelectShowModeComponent } from './components/select-show-mode/select-show-mode.component';
import { SelectFilterComponent } from './components/select-filter/select-filter.component';
import { SelectComponent } from './components/select/select.component';
import { RadioGroupComponent } from './components/radio-group/radio-group.component';
import { TextareaComponent } from './components/textarea/textarea.component';
import { FileUploaderComponent } from './components/file-uploader/file-uploader.component';
import { HttpClientModule } from '@angular/common/http';
import { BaseFormModule } from 'base-form';
import { ButtonModule } from 'primeng/button';
import { ReactiveFormsModule } from '@angular/forms';
import { MultiSelectModule } from 'primeng/multiselect';
import { DropdownModule } from 'primeng/dropdown';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FileUploadModule } from 'primeng/fileupload';
import { TextInputComponent } from './components/text-input/text-input.component';
import { PasswordInputComponent } from './components/password-input/password-input.component';
import { NumberInputComponent } from './components/number-input/number-input.component';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { DatepickerComponent } from './components/datepicker/datepicker.component';
import { CalendarModule } from 'primeng/calendar';
import { KeyFilterModule } from 'primeng/keyfilter';
import { ListboxModule } from 'primeng/listbox';
import { MfpcFilesComponent } from './components/mfpc-files/mfpc-files.component';
import {
  MfpcShowFileDialogComponent
} from './components/mfpc-show-file-dialog/mfpc-show-file-dialog.component';
import { MessagesComponent } from './components/messages/messages.component';
import { FormFieldDirective } from './directives/form-field.directive';

@NgModule({
  declarations: [
    MfpcPrimeComponent,
    ArrSmartComponent,
    ArrSmartShowModeComponent,
    SelectShowModeComponent,
    SelectFilterComponent,
    SelectComponent,
    RadioGroupComponent,
    TextareaComponent,
    FileUploaderComponent,
    TextInputComponent,
    PasswordInputComponent,
    NumberInputComponent,
    DatepickerComponent,
    MfpcFilesComponent,
    MfpcShowFileDialogComponent,
    MessagesComponent,
    FormFieldDirective,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    BaseFormModule,
    ButtonModule,
    ReactiveFormsModule,
    MultiSelectModule,
    DropdownModule,
    RadioButtonModule,
    CheckboxModule,
    InputTextareaModule,
    FileUploadModule,
    InputNumberModule,
    InputTextModule,
    PasswordModule,
    CalendarModule,
    KeyFilterModule,
    ListboxModule,
  ],
  providers: [],
  exports: [MfpcPrimeComponent, MfpcShowFileDialogComponent, MfpcFilesComponent]
})
export class PrimeMfpcModule {
  static forRoot(apiUrl: string): ModuleWithProviders<PrimeMfpcModule> {
    return {
      ngModule: PrimeMfpcModule,
      providers: [
        {
          provide: 'apiToken',
          useValue: apiUrl,
        },
      ]
    }
  }
}
